<template>
<div v-if="saibyouga">
<v-container fluid class="ma-0">
    <v-row justify="space-between">
        <v-col cols="4" class="text-left">
            <v-row v-if="!edit_mode" justify="end" class="ma-0">
                <v-col cols="12" class="text-left">
                    <div class="d-flex align-center">
                        <v-btn @click="csv_download()" class="mygreen white--text mr-3" style="margin-top: 7px;"> CSVエクスポート </v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="edit_mode" justify="start" class="ma-0">
                <v-col cols="4" class="text-left">
                    <v-btn @click="cancel()" color="" class="">
                    キャンセル</v-btn>
                </v-col>
                <v-col cols="4" class="text-left">
                    <v-btn @click="save()" color="mygreen" class="white--text mr-5">保存</v-btn>
                </v-col>
            </v-row>
        </v-col>


        <v-col cols="8" class="text-right">
            <v-row justify="end" class="ma-0">
                <v-col cols="7" class="text-right">
                    <div class="d-flex align-center">
                        <!-- 出勤・退勤ボタン -->
                        <v-btn @click="dakoku('start')"
                               :color="startButtonColor"
                               :disabled="isStartDisabled"
                               class="white--text mr-2">
                          出勤
                        </v-btn>
                        <v-btn @click="dakoku('end')"
                               :color="endButtonColor"
                               :disabled="isEndDisabled"
                               class="white--text mr-2">
                          退勤
                        </v-btn>

                        <div style="padding-bottom: 8px;">スタッフ名</div>
                        <v-select dense class="myselect text-right  ml-auto"
                            v-model="staff_selected"
                            :items="arr_staff"
                            item-text="name"
                            item-value="id"
                            menu-props="auto"
                            outlined
                            placeholder="未選択"
                            :disabled="!is_admin"
                            :rules="[v => !!v || '必須項目です.']"
                        ></v-select>
                    </div>
                </v-col>

                <v-col cols="2" class="text-right myselect2">
                    <!-- 年 -->
                    <v-select dense
                        v-model="selected_year"
                        :items="arr_year"
                        item-text="text"
                        item-value="value"
                        menu-props="auto"
                        outlined
                        placeholder="選択してください"
                        style="max-width: 130px;"
                    ></v-select>
                </v-col>

                <v-col cols="2" class="text-right ml-0 myselect2">
                    <!-- 月 -->
                    <v-select dense
                        v-model="selected_month"
                        :items="arr_month"
                        menu-props="auto"
                        outlined
                        placeholder="選択してください"
                        style="max-width: 130px;"
                    ></v-select>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</v-container>

<!-- シフト未登録時のメッセージ表示 -->
<div v-if="isNoShiftData" class="text-center pa-5 mt-5">
  <v-alert
    type="warning"
    prominent
    border="left"
    colored-border
    elevation="2"
  >
    <h3 class="mb-3">{{ selected_year }}年{{ selected_month }}月のシフトが未登録です</h3>
    <p class="mb-4">シフト管理画面で登録してください</p>
    <v-btn color="primary" @click="goToShiftPage()">シフト管理画面へ</v-btn>
  </v-alert>
</div>

<!-- 通常の勤怠データ表示 -->
<div v-else>
  <div data-v-22314e6a="" class="v-data-table elevation-1 v-data-table--fixed-header v-data-table--has-bottom theme--light">
    <div class="v-data-table__wrapper">
      <table class="mb-8">
        <colgroup>
          <col class="1"><col class="2"><col class="3"><col class="4"><col class="5"><col class="6"><col class="7"><col class="8">
        </colgroup>
        <thead class="v-data-table-header"> <tr>
            <th role="columnheader" scope="col" aria-label="シフト提出日数: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>シフト提出日数</span></th>
            <th role="columnheader" scope="col" aria-label="総労働日数: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>総労働日数</span></th>
            <th role="columnheader" scope="col" aria-label="総労働時間: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>総労働時間</span></th>
            <th role="columnheader" scope="col" aria-label="所定内労働時間: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>所定内労働時間</span></th>
            <th role="columnheader" scope="col" aria-label="所定不足時間: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>所定不足時間</span></th>
            <th role="columnheader" scope="col" aria-label="総残業時間: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>総残業時間</span></th>
            <th role="columnheader" scope="col" aria-label="総遅刻時間: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>総遅刻時間</span></th>
            <th role="columnheader" scope="col" aria-label="総早退時間: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>総早退時間</span></th>
            <th role="columnheader" scope="col" aria-label="60時間越法定外残業時間: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>60時間越法定外残業時間</span></th>
        </tr> </thead>

        <tbody>
        <tr>
            <td class="text-start">{{ headers.total_shift_days }}</td> <!-- シフト提出日 -->
            <td class="text-start">{{headers.total_actual_work_days}}</td><!-- 総労働日数 -->
            <td class="text-start">{{total_roudou}}</td><!-- 総労働時間 -->
            <td class="text-start">{{headers.total_syotei}}</td><!-- 所定内労働時間 -->
            <td class="text-start">{{total_fusoku}}</td><!-- 所定不足時間 -->
            <td class="text-start">{{total_zangyou}}</td><!-- 残業時間 -->
            <td class="text-start">{{total_chikoku}}</td><!-- 総遅刻時間 -->
            <td class="text-start">{{total_soutai}}</td><!-- 総早退時間 -->
            <td class="text-start">{{headers.total_over}}</td><!-- 60over -->
        </tr>
        </tbody>
      </table>

      <table>
        <colgroup><col class="1"><col class="2"><col class="3"><col class="4"><col class="5"><col class="6"><col class="7"><col class="8"><col class="9"></colgroup>
        <thead class="v-data-table-header"> <tr>
            <th role="columnheader" scope="col" aria-label="日付: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>日付</span>
            </th><th role="columnheader" scope="col" aria-label="勤務状況: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>勤務状況</span>
            </th><th role="columnheader" scope="col" aria-label="実績(出勤): Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>実績(出勤)</span>
            </th><th role="columnheader" scope="col" aria-label="実績(退勤): Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>実績(退勤)</span>
            </th><th role="columnheader" scope="col" aria-label="休憩時間: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>休憩時間</span>
            </th><th role="columnheader" scope="col" aria-label="労働時間: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>労働時間</span>
            </th><th role="columnheader" scope="col" aria-label="残業時間: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>残業時間</span>
            </th><th role="columnheader" scope="col" aria-label="遅刻時間: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>遅刻時間</span>
            </th><th role="columnheader" scope="col" aria-label="早退時間: Not sorted. Activate to sort ascending." aria-sort="none" class="text-start"><span>早退時間</span>
            </th>
        </tr> </thead>

        <tbody>
          <tr v-for="(v, index) in records" :key="v.id" class="myfield" :class="{'text-red-holiday': isSpecialHoliday(v.yuukyuu)}">
            <!-- 日付 (変更なし) -->
            <td class="text-start">{{mydate(v.date)}}</td>

            <!-- 勤務状況ラベル -->
            <td class="text-start">
              <template v-if="v.yuukyuu === '午前休'">
                <div>午前休</div>
                <div>午後勤務</div>
              </template>
              <template v-else-if="v.yuukyuu === '午後休'">
                <div>午前勤務</div>
                <div>午後休</div>
              </template>
              <template v-else-if="v.yuukyuu === '全休'">全休</template>
              <template v-else-if="v.yuukyuu !== ''">{{ v.yuukyuu }}</template>
              <template v-else>{{ v.state }}</template>
            </td>

            <!-- 出勤時間 -->
            <td @dblclick="editTime(v, $event)"
                :class="{'text-start': true}"
                style="width:100px;">
              <template v-if="v.yuukyuu === '午前休'">
                <div>09:00</div> <!-- 固定 & 編集不可 -->
                <div>
                  <input v-show="edit_mode"
                         :data-date="v.date"
                         data-field="start"
                         type="text" :value="v.start" style="width:66px; max-width:66px;">
                  <span v-show="!edit_mode" :class="{'text_red': is_over_start(v)}">{{v.start || '--:--'}}</span>
                </div>
              </template>
              <template v-else-if="v.yuukyuu === '午後休'">
                <div>
                  <input v-show="edit_mode"
                         :data-date="v.date"
                         data-field="start"
                         type="text" :value="v.start" style="width:66px; max-width:66px;">
                  <span v-show="!edit_mode" :class="{'text_red': is_over_start(v)}">{{v.start || '--:--'}}</span>
                </div>
                <div>15:00</div> <!-- 固定 & 編集不可 -->
              </template>
              <template v-else-if="v.yuukyuu === '全休'">09:00</template> <!-- 固定 & 編集不可 -->
              <template v-else-if="v.state === '休日'">--:--</template> <!-- 固定 & 編集不可 -->

              <template v-else > <!-- 通常 or その他の編集可能な休暇 -->
                <input v-show="edit_mode"
                       :data-date="v.date"
                       data-field="start"
                       type="text" :value="v.start" style="width:66px; max-width:66px;"
                >
                <span v-show="!edit_mode" :class="{'text_red': is_over_start(v)}">{{v.start || '--:--'}}</span>
              </template>
            </td>

            <!-- 退勤時間 -->
            <td @dblclick="editTime(v, $event)"
                :class="{'text-start': true}"
                style="width:100px;">
              <template v-if="v.yuukyuu === '午前休'">
                <div>13:00</div> <!-- 固定 & 編集不可 -->
                <div>
                  <input v-show="edit_mode"
                         :data-date="v.date"
                         data-field="end"
                         type="text" :value="v.end" style="width:66px; max-width:66px;">
                  <span v-show="!edit_mode" :class="{'text_red': is_early_leave(v)}">{{v.end || '--:--'}}</span>
                </div>
              </template>
              <template v-else-if="v.yuukyuu === '午後休'">
                <div>
                  <input v-show="edit_mode"
                         :data-date="v.date"
                         data-field="end"
                         type="text" :value="v.end" style="width:66px; max-width:66px;">
                  <span v-show="!edit_mode" :class="{'text_red': is_early_leave(v)}">{{v.end || '--:--'}}</span>
                </div>
                <div>19:00</div> <!-- 固定 & 編集不可 -->
              </template>
              <template v-else-if="v.yuukyuu === '全休'">19:00</template> <!-- 固定 & 編集不可 -->
              <template v-else-if="v.state === '休日'">--:--</template> <!-- 固定 & 編集不可 -->

              <template v-else> <!-- 通常 or その他の編集可能な休暇 -->
                <input v-show="edit_mode"
                       :data-date="v.date"
                       data-field="end"
                       type="text" :value="v.end" style="width:66px; max-width:66px;">
                <span v-show="!edit_mode" :class="{'text_red': is_early_leave(v)}">{{v.end || '--:--'}}</span>
              </template>
            </td>

            <!-- 休憩時間 (1行固定) -->
            <td class="text-start">{{ v.kyukei }}</td>

            <!-- 労働時間 -->
            <td class="text-start roudou">{{ v.roudou }}</td>

            <!-- 残業時間 -->
            <td class="text-start zangyou">{{ v.zangyou }}</td>

            <!-- 遅刻時間 -->
            <td class="text-start chikoku">{{ v.chikoku }}</td>

            <!-- 早退時間 -->
            <td class="text-start soutai">{{ v.soutai }}</td>

            <span v-if="index===(records.length-1)" style="display:none"></span>
          </tr>
        </tbody>

      </table>
    </div>
  </div>
</div>

</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex'
/* eslint-disable */

export default {

  components:{
  },


  data(){  // datas
      return {
          saibyouga: true,
          isNoShiftData: false,
          edit_ok: false,  // ドロップダウンのwatch の無限ループ回避のため編集できる状態にあるか確認
          strict: false,
          total_minutes: 0,
          count_roudou:0,
          headers: {total_actual_work_days:20, total_roudou: '00:00', total_syotei: '00:00', total_fusoku: '00:00', total_zangyou: '00:00', total_chikoku: '00:00', total_soutai: '00:00', total_over: '00:00'},
          edit_mode:false,
          
          // 今日の勤怠状態
          todayKintai: {
              start: "--:--",
              end: "--:--",
              date: null,
              state: "--"
          },

          arr_staff: [
            /*
              {'id': 1, 'name':'医師 一太'},
              {'id': 2, 'name':'医師 ニ太'}
              */
          ],
          staff_selected: null,

          today: ''+new Date().getFullYear() + (''+(new Date().getMonth()+1)).padStart(2, '0'),
          selected_year: ''+new Date().getFullYear(),
          selected_month:  (''+(new Date().getMonth()+1)).padStart(2, '0'),


          arr_year: [{text:'2022年', value:'2022'},{text:'2023年', value:'2023'},{text:'2024年', value:'2024'},{text:'2025年', value:'2025'},{text:'2026年', value:'2026'},{text:'2027年', value:'2027'},{text:'2028年', value:'2028'},{text:'2029年', value:'2029'},{text:'2030年', value:'2030'}],
          arr_month: [{text:'01月', value:'01'},{text:'02月', value:'02'},{text:'03月', value:'03'},{text:'04月', value:'04'},{text:'05月', value:'05'},{text:'06月', value:'06'},{text:'07月', value:'07'},{text:'08月', value:'08'},{text:'09月', value:'09'},{text:'10月', value:'10'},{text:'11月', value:'11'},{text:'12月', value:'12'}],


        staff_id: 0,


        date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu1: false,
        menu2: false,
        modal: false,


        title: '患者一覧',
        tableHeight: 700,
        dialog: false,
        dialogDelete: false,
        shift: [],
        records: [
         /*   {staff_id:1, date: '2022-07-01', state:'終日勤務', start:'08:29', end:'19:00', kyuukei:'01:30', roudou:'00:00', zangyou:'00:00', chikoku:'00:00', soutai:'00:00'},*/

        ],
        editedIndex: -1,
        editedItem: {
          name: '',
          calories: 0,
          fat: 0,
          carbs: 0,
          protein: 0,
        },
        defaultItem: {
          name: '',
          calories: 0,
          fat: 0,
          carbs: 0,
          protein: 0,
        },

        search_mode: false,
      }
  },  // datas

  async created () {
      console.log('%c created: KintaiView.vue', mycolor.created);
      console.log('%c today: '+this.today, 'background: green; font-size: 20px;');


      let res = await axios.get('/get_staffs');
      console.log('待つよ');
      console.log(res.data);

      // 管理者は除外
      this.arr_staff =res.data.filter( v => {
            return v.id!=0;
      });

      console.log(this.user);
      if(this.user.id==0){
          // adminの場合は、一番idの若いスタッフをデフォルト表示する
          this.staff_selected = this.arr_staff[0]['id'];
      }else{
          this.staff_selected = this.user.id;
      }

      this.getKintai();  // staff_idが決まってから初期化する



      // QRコード打刻リアルタイム反映のため
      // todo: websocketで
      //  this.interval = setInterval(() => {
      //    if(!this.edit_mode){
      //      this.getKintai();
      //    }
      //  }, this.$interval_time);

  },
  computed: {
      ...mapGetters(['user', 'user_name', 'is_admin']),
      
      // 今日が休日かどうか
      isHoliday() {
          return this.todayKintai.state === '休日';
      },
      
      // 出勤ボタンの色
      startButtonColor() {
          if (this.isHoliday) return 'grey';  // 休日：グレー
          if (!this.todayKintai.start || this.todayKintai.start === '--:--') return 'mygreen';  // 未出勤：CSVボタンと同じ色
          return 'grey';  // 出勤済み：グレー
      },
      
      // 退勤ボタンの色
      endButtonColor() {
          if (this.isHoliday) return 'grey';  // 休日：グレー
          if ((this.todayKintai.start && this.todayKintai.start !== '--:--') && 
              (!this.todayKintai.end || this.todayKintai.end === '--:--')) return 'mygreen';  // 出勤済み・未退勤：緑
          return 'grey';  // それ以外：グレー
      },
      
      // 出勤ボタンの無効化
      isStartDisabled() {
          if (this.isHoliday) return true;  // 休日なら無効
          return !!(this.todayKintai.start && this.todayKintai.start !== '--:--');  // 既に出勤済みなら無効
      },
      
      // 退勤ボタンの無効化
      isEndDisabled() {
          if (this.isHoliday) return true;  // 休日なら無効
          return !this.todayKintai.start || this.todayKintai.start === '--:--' || 
                 (this.todayKintai.end && this.todayKintai.end !== '--:--');  // 未出勤または退勤済みなら無効
      },
      
      total_roudou(){
          console.log('total_roudou');

          var _seconds = this.headers.total_roudou;
          if( Number.isInteger(_seconds) && _seconds>0 ){
              var _hour = Math.floor( _seconds/(60*60) );
              var _minutes = Math.floor( (_seconds - _hour*60*60)/60 );
              _hour = _hour.toString().padStart(2, '0');
              _minutes = _minutes.toString().padStart(2, '0');

              return _hour + ':' + _minutes;
          }else{
              return '00:00';
          }
      },
      total_fusoku(){
          // 所定不足時間
          var _seconds = this.headers.total_roudou;
          _seconds = this.headers.total_syotei*60*60 - _seconds;
          if( Number.isInteger(_seconds) && _seconds>0 ){
              var _hour = Math.floor( _seconds/(60*60) );
              var _minutes = Math.floor( (_seconds - _hour*60*60)/60 );
              _hour = _hour.toString().padStart(2, '0');
              _minutes = _minutes.toString().padStart(2, '0');

              return _hour + ':' + _minutes;
          }else{
              return '00:00';
          }
      },
      total_zangyou(){
          // 総残業時間
          var _seconds = this.headers.total_zangyou;
          if( Number.isInteger(_seconds) && _seconds>0 ){
              var _hour = Math.floor( _seconds/(60*60) );
              var _minutes = Math.floor( (_seconds - _hour*60*60)/60 );
              _hour = _hour.toString().padStart(2, '0');
              _minutes = _minutes.toString().padStart(2, '0');

              return _hour + ':' + _minutes;
          }else{
              return '00:00';
          }
      },
      total_chikoku(){
          // 総残業時間
          var _seconds = this.headers.total_chikoku;
          if( Number.isInteger(_seconds) && _seconds>0 ){
              var _hour = Math.floor( _seconds/(60*60) );
              var _minutes = Math.floor( (_seconds - _hour*60*60)/60 );
              _hour = _hour.toString().padStart(2, '0');
              _minutes = _minutes.toString().padStart(2, '0');

              return _hour + ':' + _minutes;
          }else{
              return '00:00';
          }
      },
      total_soutai(){
          // 総残業時間
          var _seconds = this.headers.total_soutai;
          if( Number.isInteger(_seconds) && _seconds>0 ){
              var _hour = Math.floor( _seconds/(60*60) );
              var _minutes = Math.floor( (_seconds - _hour*60*60)/60 );
              _hour = _hour.toString().padStart(2, '0');
              _minutes = _minutes.toString().padStart(2, '0');

              return _hour + ':' + _minutes;
          }else{
              return '00:00';
          }
      },
  },

  watch: {
    // 年月ドロップダウン変更
    selected_year(newval, oldval){
        console.log('%c selected_year', 'background: green;font-size: 20px;');
        console.log(oldval + '→' + newval);

        // 編集モードから離脱時
        if(this.edit_mode){
            let yes = confirm('現在の入力内容が保存されませんがよろしいですか?');
            if(yes){
                this.edit_mode = false;
            }else{
                this.selected_year = oldval;
                return false;
            }
        }

        this.getStaffShift('year', oldval);

    },

    selected_month(newval, oldval){
        console.log('%c selected_month', 'background: green;font-size: 20px;');
        console.log(oldval, '->', newval);


        // 編集モードから離脱時
        if(this.edit_mode){
            let yes = confirm('現在の入力内容が保存されませんがよろしいですか?');
            if(yes){
                this.edit_mode = false;
            }else{
                this.selected_month = oldval;
                return false;
            }
        }

        this.getStaffShift('month', oldval);

    },

    // 医師のドロップダウン変更
    staff_selected(newval, oldval){
        console.log('%c staff_selected', 'background: green;font-size: 20px;');
        console.log(oldval, '->', newval);


        // 編集モードから離脱時
        if(this.edit_mode){
            let yes = confirm('現在の入力内容が保存されませんがよろしいですか?');
            if(yes){
                this.edit_mode = false;
            }else{
                this.staff_selected = oldval;
                return false;
            }
        }

        this.getStaffShift('staff', oldval);
        
        // 今日の勤怠状態も取得
        this.getTodayKintai();

    },

    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },

    $user (newval, oldval) {
          console.log(oldval, '->', newval);
          this.staff_id = newval.id;
          this.staff_selected = newval.id;

          console.log('%c staff_id'+this.staff_id, 'background: purple;font-size: 20px;');


          if( this.user.auth==='一般' ){
              this.strict = true;
          }
          this.getKintai();
          
          // 今日の勤怠状態も取得
          this.getTodayKintai();
    },

  },

  mounted () {
    console.log('mounted');
  },

  methods: {
      // 打刻処理メソッド
      async dakoku(type) {
          console.log(`%c dakoku(${type})`, 'background: green;font-size: 16px;');
          
          if (!this.staff_selected) {
              alert('スタッフを選択してください');
              return;
          }
          
          try {
              let response;
              
              // typeに応じて適切なAPIを呼び分け
              if (type === 'start') {
                  response = await axios.post(this.$fastapi + '/kintai_shukkin', {
                      staff_id: this.staff_selected  // 数値のまま送信
                  });
              } else {
                  response = await axios.post(this.$fastapi + '/kintai_taikin', {
                      staff_id: this.staff_selected  // 数値のまま送信
                  });
              }
              
              console.log('打刻レスポンス:', response.data);
              
              // レスポンスの内容をチェック
              if (response.data.status === 'success') {
                  // 成功時：今日の勤怠状態を更新
                  await this.getTodayKintai();  // ボタン状態更新
                  this.getKintai();             // テーブル全体を更新
                  alert(`${response.data.message} (${response.data.time})`);
              } else {
                  // エラー時
                  alert(response.data.message);
              }
              
          } catch (error) {
              console.error('打刻処理エラー:', error);
              if (error.response && error.response.data && error.response.data.detail) {
                  alert(`エラー: ${error.response.data.detail}`);
              } else {
                  alert('打刻処理でエラーが発生しました');
              }
          }
      },
      
      // 今日の勤怠状態取得メソッド
      async getTodayKintai() {
          console.log('%c getTodayKintai()', 'background: blue;font-size: 16px;');
          
          if (!this.staff_selected) {
              return;
          }
          
          try {
              const response = await axios.get(this.$fastapi + '/get_today_kintai/' + this.staff_selected);
              
              console.log('今日の勤怠状態:', response.data);
              
              // 取得したデータでtodayKintaiを更新
              this.todayKintai = {
                  start: response.data.start,
                  end: response.data.end,
                  date: response.data.date,
                  state: response.data.state
              };
              
          } catch (error) {
              console.error('今日の勤怠状態取得エラー:', error);
              // エラー時は初期値に戻す
              this.todayKintai = {
                  start: "--:--",
                  end: "--:--",
                  date: null,
                  state: "--"
              };
          }
      },
      
      isSpecialHoliday(yuukyuuValue) {
        return ['全休', '午前休', '午後休'].includes(yuukyuuValue);
      },

      KintaiDakoku(){
          console.log('%c KintaiDakoku()', mycolor.strong);
          this.getKintai();

          //this.saibyouga = false;
          //this.$nextTick( () => (this.saibyouga = true) );
          //console.log('再描画完了');
      },
      csv_download(){
        console.group();
        console.log('%c %s', mycolor.strong, '/download2');
        console.log(this.records);
        console.groupEnd();


          axios.post( '/download_kintai_csv')
            .then( (res) => {

                console.group();
                console.log('%c %s', mycolor.api, '/download_kintai_csv');
                console.log(res);
                console.groupEnd();

                  const name = res.headers["content-disposition"];
                  const bom = new Uint8Array([0xef, 0xbb, 0xbf]); // utf-8で文字化けさせないためにBOMを付ける
                  const blob = new Blob([bom, res.data], { type: 'text/csv', });


                  // ファイル名決める
                  let today = new Date();
                  // today.toLocaleString();   // 時間まで欲しければこっち! '2022/8/23 9:07:28'
                  let today_text = today.toLocaleDateString();  // '2022/8/23'
                  let yyyy = today_text.replace(/^(\d+)\/(\d+)\/(\d+)/mg, '$1');
                  let mm = today_text.replace(/^(\d+)\/(\d+)\/(\d+)/mg, '$2').padStart(2, '0');
                  let dd = today_text.replace(/^(\d+)\/(\d+)\/(\d+)/mg, '$3').padStart(2, '0');

                  let CSV_NAME = yyyy + mm + dd + '.csv';

                  saveAs(blob, CSV_NAME);

            })
            .catch(() => {
              console.error('error');
            });

          return false;
      },


      roudou(start, end, d, state) {

          console.log('%c %s', mycolor.strong, 'roudou()');
          console.log('d', d);
          console.log('state', state);
          console.log('start', start);
          console.log('end', end);
          // 労働時間を算出
          // 退勤時間 - 出勤時間 - 休憩時間
          if(start==='--:--' || end==='--:--'){
              return '--:--';
          }

          // 休憩時間
          var kyukei = this.kyukei(d, state);
          if(kyukei==='01:30'){
              kyukei = 90;
          }else if(kyukei==='00:45'){
              kyukei = 45;
          }else{
              kyukei = 0;
          }

          // (退勤時間 - 出勤時間)>0なら 休憩時間を引く
          var timeStart = new Date("01/01/2007 " + start).getTime();
          var timeEnd = new Date("01/01/2007 " + end).getTime();
          var minutesDiff = (timeEnd - timeStart)/1000/60;
          if(minutesDiff > kyukei){
              minutesDiff -= kyukei
          }
          var hourDiff = Math.floor( minutesDiff/60 );

          // 分
          minutesDiff = minutesDiff - hourDiff*60;
          minutesDiff = minutesDiff.toString().padStart(2, '0');

          if(hourDiff<0){
              return '--:--';
          }

          hourDiff = hourDiff.toString().padStart(2, '0');


          return hourDiff + ':' + minutesDiff;
      },

      // 2. getStaffShift関数
      async getStaffShift(which, oldval) {
        console.log('%c which: '+which, 'background: green;font-size: 18px;');
        console.log('%c oldval: '+oldval, 'background: green;font-size: 18px;');

        axios.get('/get_staff_shift/' + this.staff_selected + '/' + this.selected_year + '/' + this.selected_month)
          .then(res => {
            console.group();
            console.log('%c /get_staff_shift/' + this.staff_selected + '/' + this.selected_year + '/' + this.selected_month, mycolor.api);
            console.log(res.data);
            console.groupEnd();

            if(res.data.length == 0) {
              // シフトが未登録の場合
              this.isNoShiftData = true; // 未登録フラグをON

              // アラートは出さない！

              // 選択値は元に戻さない - ユーザーが選んだ年月をそのまま表示
              // ドロップダウンで選択した年月をそのまま維持する
            } else {
              // 通常通りデータがある場合
              this.isNoShiftData = false; // 未登録フラグをOFF
              this.getKintai();
            }
          })
          .catch(() => {
            console.error('シフト情報の取得中にエラーが発生しました');
          });
      },

      // 3. goToShiftPage関数
      goToShiftPage() {
        // 確認なしで直接遷移
        location.href = '/shift';
      },



      editTime(v, e){
        console.log('editTime()');
        if( !this.is_admin || this.edit_mode){
            console.log('権限がありません');
            return false;
        }
        this.edit_mode = true;
      },


    is_over_start(v) {
        // こいつは、「おっと、もしかして遅刻しちゃった？😱」をチェックするイカした関数だぜ！
        // 休暇中なら、そもそも比較の必要なし！セーフ！👍
        if (v.yuukyuu === '全休') {
            return false;
        }

        // 🆕 シフト開始時刻 (v.shift_start) が有効かチェック！
        // 空っぽだったり、"--:--" だったら、比べる相手がいないから遅刻とは言えないぜ！😎
        if (!v.shift_start || v.shift_start === "" || v.shift_start === "--:--") {
            // console.log('is_over_start: シフト開始時刻が未設定なのでセーフ！');
            return false;
        }

        // 🆕 実際の出勤時刻 (v.start) が有効かチェック！
        // こっちも空っぽだったり、"--:--" だったら、遅刻とは判断できないよな！
        if (!v.start || v.start === "" || v.start === "--:--") {
            // console.log('is_over_start: 実際の出勤時刻が未入力なのでセーフ！');
            return false;
        }

        // '01/01/2007 ' は時間比較のためのおまじないだぜ！🧙‍♂️
        // getTime() でミリ秒に変換して比較するぜ！
        var shift_start_ms = new Date("01/01/2007 " + v.shift_start).getTime();
        var actual_start_ms = new Date("01/01/2007 " + v.start).getTime();

        // 🆕 時刻文字列が変な値で Date オブジェクトが NaN (Not a Number) になっちゃった場合も考慮！
        // これで、予期せぬ入力があってもエラーで止まったり、変な動きをするのを防げるぜ！👍
        if (isNaN(shift_start_ms) || isNaN(actual_start_ms)) {
            console.warn(`is_over_start: おっとっと、時刻の形が変だぜ？ date='${v.date}', shift_start='${v.shift_start}', start='${v.start}'`);
            return false; // 不正な時刻なら、遅刻とはみなさないでおこうぜ！安全第一！👷‍♂️
        }

        // いよいよ本番の比較だ！🔥
        // 実際の出勤時刻 (actual_start_ms) が、シフトの開始時刻 (shift_start_ms) より後だったら…
        if (actual_start_ms > shift_start_ms) {
            // console.log(`is_over_start: 遅刻だぜ！😱 date='${v.date}', shift='${v.shift_start}', actual='${v.start}'`);
            return true; // 遅刻フラグON！🚩
        }

        // ここまで来たら、遅刻じゃないってことだ！セーフ！🎉
        return false;
    },

    is_early_leave(v) { // 早退チェック
        // 休暇中なら、早退も何もないからセーフ！👍
        if (v.yuukyuu === '全休') {
            return false;
        }

        // 🆕 シフト終了時刻 (v.shift_end) が有効かチェック！
        // 空っぽだったり、"--:--" だったら、比べる相手がいないから早退とは言えないぜ！😎
        if (!v.shift_end || v.shift_end === "" || v.shift_end === "--:--") {
            // console.log('is_early_leave: シフト終了時刻が未設定なのでセーフ！');
            return false;
        }

        // 🆕 実際の退勤時刻 (v.end) が有効かチェック！
        // こっちも空っぽだったり、"--:--" だったら、早退とは判断できないよな！
        if (!v.end || v.end === "" || v.end === "--:--") {
            // console.log('is_early_leave: 実際の退勤時刻が未入力なのでセーフ！');
            return false;
        }

        // '01/01/2007 ' は時間比較のためのおまじないだぜ！🧙‍♂️
        // getTime() でミリ秒に変換して比較するぜ！
        var shift_end_ms = new Date("01/01/2007 " + v.shift_end).getTime();
        var actual_end_ms = new Date("01/01/2007 " + v.end).getTime();

        // 🆕 時刻文字列が変な値で Date オブジェクトが NaN になっちゃった場合も考慮！
        if (isNaN(shift_end_ms) || isNaN(actual_end_ms)) {
            console.warn(`is_early_leave: おっとっと、時刻の形が変だぜ？ date='${v.date}', shift_end='${v.shift_end}', end='${v.end}'`);
            return false; // 不正な時刻なら、早退とはみなさないでおこうぜ！安全第一！👷‍♂️
        }

        // いよいよ本番の比較だ！🔥
        // 実際の退勤時刻 (actual_end_ms) が、シフトの終了時刻 (shift_end_ms) より前だったら…
        if (actual_end_ms < shift_end_ms) {
            // console.log(`is_early_leave: 早退だぜ！💨 date='${v.date}', shift='${v.shift_end}', actual='${v.end}'`);
            return true; // 早退フラグON！🚩
        }

        // ここまで来たら、早退じゃないってことだ！最後までお疲れ様！🎉
        return false;
    },

    mydate (d) {
      const weekday = ["日", "月", "火", "水", "木", "金", "土"];
      let mydate = new Date(d);

      return d + ' (' + weekday[mydate.getDay()] + ')';
    },


    getKintai () {
      console.log('getKintai()');

      axios.post( '/kintai/'+this.staff_selected + '/' + this.selected_year + '/' + this.selected_month )
        .then( (res) => {

            // APIのレスポンスが辞書形式になったので、キーでアクセスするぜ！
            this.headers = res.data.summary;          // ヘッダー情報
            this.shift   = res.data.shift_schedule;   // 当月のシフト
            this.records = res.data.daily_kintai;     // 当月の勤怠実績

            console.group()
            console.log(`%c `+ '/kintai/'+this.staff_selected  + '/' + this.selected_year + '/' + this.selected_month , mycolor.api);
            console.log('勤怠データ取得完了 (新しい形式だぜ！✨)');
            console.log('headers (summary): ', this.headers);
            console.log('shift (shift_schedule): ', this.shift);
            console.log('records (daily_kintai): ', this.records);
            console.groupEnd();
        })
        .catch( (error) => { // エラーハンドリングもちょっと詳しくしとこうぜ！
            console.error('勤怠データの取得でエラー発生だぜ！😱', error);
            // ここでユーザーにエラーを通知する処理とかも入れられるな！
        });

    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },



    async save () {
      console.group();
      console.log('%c save() - Final Version with Validation!', mycolor.strong); // ちょっとバージョン名変えといたぜ！

      // 時刻形式をチェックする正規表現 (HH:MM または --:--)
      const timeFormatRegex = /^(\d{2}:\d{2}|--:--)$/;
      const kintaiDataToSend = [];

      // 表示されている各日付の行 (this.records) を基準にループ
      for (const record of this.records) {
          const recordDate = record.date;
          let rawStartValue = record.start; // 編集前の生の開始時刻
          let rawEndValue = record.end;     // 編集前の生の終了時刻

          if (this.edit_mode) { // 編集モードの時だけDOMから値を取得
              const startInput = document.querySelector(`input[data-date="${recordDate}"][data-field="start"]`);
              const endInput = document.querySelector(`input[data-date="${recordDate}"][data-field="end"]`);

              if (startInput && startInput.offsetParent !== null) {
                  rawStartValue = startInput.value.trim(); // DOMからの生の入力値
              }
              if (endInput && endInput.offsetParent !== null) {
                  rawEndValue = endInput.value.trim();   // DOMからの生の入力値
              }
          }

          // APIに送信する最終的な値 (空文字列なら '--:--' にフォールバック)
          const finalStartToSave = rawStartValue || '--:--';
          const finalEndToSave = rawEndValue || '--:--';

          // --- ここからバリデーション！ ---
          if (!timeFormatRegex.test(finalStartToSave)) {
              // バリデーションNGの場合、ユーザーが実際に入力した rawStartValue を見せるのが親切だぜ！
              alert(`【入力エラー：出勤時刻 ⏰】\n日付: ${recordDate}\n入力された値: "${rawStartValue}"\n\n正しい形式は「HH:MM」（例: 09:30）または「--:--」です。\n空欄のままでもOKです！`);
              console.warn(`バリデーションエラー (出勤): date=${recordDate}, rawInput="${rawStartValue}", processedValue="${finalStartToSave}"`);
              console.groupEnd(); // 忘れずに groupEnd
              return; // 処理を中断して関数を抜ける！
          }

          if (!timeFormatRegex.test(finalEndToSave)) {
              alert(`【入力エラー：退勤時刻 🏁】\n日付: ${recordDate}\n入力された値: "${rawEndValue}"\n\n正しい形式は「HH:MM」（例: 18:00）または「--:--」です。\n空欄のままでもOKです！`);
              console.warn(`バリデーションエラー (退勤): date=${recordDate}, rawInput="${rawEndValue}", processedValue="${finalEndToSave}"`);
              console.groupEnd(); // 忘れずに groupEnd
              return; // 処理を中断して関数を抜ける！
          }
          // --- バリデーションここまで ---

          kintaiDataToSend.push({
              date: recordDate,
              start: finalStartToSave, // バリデーション済みの値
              end: finalEndToSave,     // バリデーション済みの値
          });
      }

      console.log('送信するデータ (バリデーション済み):', kintaiDataToSend);
      // console.groupEnd(); // API呼び出し前に groupEnd するならここだけど、エラー時にも呼びたいから、API呼び出しの try の前が良いかも。
                         // いや、元のコードだと try の前に console.groupEnd() があるから、それに合わせるならここでOK。
                         // エラー時は return 前に呼んでるから問題なし！

      // API呼び出しの前にもう一度 groupEnd しておくのが、元のコードの流れだと自然かな。
      console.groupEnd();

      try {
          const apiUrl = `/kintai_bulk_update/${this.staff_selected}/${this.selected_year}/${this.selected_month}`;
          // console.group(); // API呼び出しごとにグループ化するならここから
          console.log(`%c API Call: ${apiUrl}`, mycolor.api_call); // 呼び出しURLもログ出しとくか！
          const response = await axios.post(apiUrl, kintaiDataToSend);

          if (response.data.status === 'OK') {
              // console.group(); // 成功ログのグループ
              console.log(`%c ${apiUrl} - SUCCESS! 🎉`, mycolor.api);
              console.log('一括保存完了！', response.data.msg);
              // console.groupEnd(); // 成功ログのグループ終了
              this.getKintai();
              await this.getTodayKintai();  // ボタン状態も更新
          } else {
              alert(`更新に失敗しました: ${response.data.msg || '不明なエラー'}`);
          }
      } catch (error) {
          console.error('一括保存APIの呼び出しでエラー発生:', error);
          let errorMsg = '更新処理中にエラーが発生しました。';
          if (error.response && error.response.data && error.response.data.detail) {
              errorMsg += `\n${error.response.data.detail}`;
          } else if (error.response && error.response.data && error.response.data.msg) {
              errorMsg += `\n${error.response.data.msg}`;
          }
          alert(errorMsg);
      } finally {
          this.edit_mode = false;
          // console.groupEnd(); // API呼び出しごとのグループを閉じるならここ
      }
    },

    cancel () {
        this.edit_mode = false;
    },
  },  // methods

}
</script>


<style scoped>
/deep/ .kana{
    font-size: 9px;
}
/deep/ .text_red{
    color: red;
}
/deep/ .v-text-field--outlined > .v-input__control > .v-input__slot{
    background: #fff;
}
/deep/ .v-text-field.v-text-field--enclosed .v-text-field__details{
    display: none;
}
/deep/ .v-input__control{
    height: 50px !important;
}
/deep/ .myfield input{
    border: 1px solid #d7d7d7;
    border-radius: 4px;
    width: 100%;
    disply: inline-block;
}


/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .v-input__append-inner{
    margin: 0 !important;
    margin: auto !important;
}
/deep/ .myselect{
    max-width: 200px;
    margin-left: 20px !important;
}
/deep/ .myselect2{
    max-width: 144px;
}
/deep/ .v-text-field.v-text-field--enclosed .v-text-field__details{
    display: none;
}
/deep/ .v-input__control{
    height: 50px !important;
}
/deep/ .text-red-holiday { /* 行全体じゃなくて、行の中の各セル(td)の文字色を変えるのが一般的かな */
  //color: red !important; /* !important は最終手段だけど、Vuetifyとか使ってると必要になるかも */
  background-color: #ffeeee; /* 薄い赤背景とか？ */
}
</style>
